const $ = require('jquery')

const { URL_API } = require('./api')
const FastMatcher = require('./fastMatcher')

const search = {
  autocomplete () {
    const $searchInput = $('.searchInput')
    const $searchResults = $('.ac-searchresults').find('.resultList')
    const $searchFormWrapper = $('.search-form')
    const blackList = []

    const loadBlacklistedWords = function() {
      return $.ajax({
        url: URL_API.pageSearchWordsBlacklist,
        dataType: 'json',
        method: 'GET',
        success: initializeWordsBlacklist,
      })
    }

    const attachSearchLoader = function() {
      const loader = '<div class="loader"><div class="loaderFigure"></div></div>'
      $searchFormWrapper.find('.searchInput').addClass('loading')
      $searchFormWrapper.find('.search-form__wrapper').append(loader)
    }

    const detachSearchLoader = function() {
      $searchFormWrapper.find('.searchInput').removeClass('loading')
      $searchFormWrapper.find('.loader').remove()
      $searchInput.removeAttr('disabled')
    }

    const loadSearchData = function() {
      return $.ajax({
        url: URL_API.pageSearch,
        dataType: 'json',
        method: 'GET',
        data: {
          p: '',
        },
        success (data) {
          initializeFastMatcher(data)
          detachSearchLoader()
        },
      })
    }

    const completeListElement = function(part, url) {
      const listElement = $(part.join(''))[0]
      listElement.firstChild.setAttribute('href', url)

      return listElement
    }

    const handleListActivityClass = function(term) {
      const $listElement = $searchResults.find('li')
      if (term.length >= 3 && $listElement.length) {
        $searchResults.addClass('list-active')
      } else {
        $searchResults.removeClass('list-active')
      }
    }

    const closeResultsList = function() {
      $searchResults.removeClass('list-active')
    }

    const selectPreviousResultItems = function() {
      // @TODO: *feature implementation* - selecting previous result item from list via keyboard UP arrow
    }

    const selectNextResultItems = function() {
      // @TODO: *feature implementation* - selecting next result item from list via keyboard DOWN arrow
    }

    const keyboardInteractions = function(e) {
      switch (e.keyCode) {
        case 27:
          closeResultsList()
          break
        case 38:
          selectPreviousResultItems()
          break
        case 40:
          selectNextResultItems()
          break
        default:
          return
      }
    }

    const initializeFastMatcher = function(data) {
      const matcher = new FastMatcher(data, {
        selector: 'SearchText',
        caseInsensitive: true,
        preserveOrder: true,
        anyWord: true,
        limit: 6,
      })

      const isForbiddenTerm = function(term) {
        const blackListState = blackList.map(function(item) {
          const reg = new RegExp(term, 'i')
          return item.toString().match(reg) ? true : false
        })

        for (let i = 0; i < blackListState.length; i++) {
          const isBlacklisted = blackListState[i]
          if (isBlacklisted == true) {
            return true
          }
        }

        return false
      }

      const renderMatches = function(matches, term) {
        const output = matches
          .map(function(item) {
            return {
              html: `<li><a>${item.HotelName}</a></li>`,
              url: item.Url,
            }
          })
          .map(function(item) {
            const spanStart = '<span class="term">'
            const spanEnd = '</span>'
            const termStartIndex = item.html.search(new RegExp(term, 'i'))
            const end = termStartIndex + term.length + 1

            const parts = item.html.split('')

            // Start number *7* is length of whole html before rendered HotelName (previous map function --> returned "html" property)
            parts.splice(7, 0, spanStart)
            parts.splice(end, 0, spanEnd)

            return completeListElement(parts, item.url)
          })

        return $searchResults.empty().append(output)
      }

      const searchTerm = function(e) {
        let $searchTerm = $(this).val()
        $searchTerm = $searchTerm.toLowerCase()

        keyboardInteractions(e)

        if (!isForbiddenTerm($searchTerm)) {
          blackList.forEach(function(item) {
            item = item.toString().toLowerCase()
            $searchTerm = $searchTerm.replace(new RegExp(item, 'g'), '')
          })
          $searchTerm = $searchTerm.trim()

          const matches = matcher.getMatches($searchTerm)
          if ($searchTerm.length >= 3) {
            renderMatches(matches, $searchTerm)
          }

          handleListActivityClass($searchTerm)
        } else {
          closeResultsList()
        }
      }

      $searchInput.on('keyup', searchTerm)
    }

    const initializeWordsBlacklist = function(data) {
      for (const prop in data) {
        blackList.push(data[prop])
      }
    }

    $(document).on('readystatechange', function() {
      if (document.readyState === 'complete') {
        loadBlacklistedWords()
        loadSearchData()
      }
    })

    $searchInput.on('focus', function() {
      $searchFormWrapper.find('.loader').show()
      if ($searchInput.hasClass('loading')) {
        $searchInput.prop('disabled', true)
      }
    })

    attachSearchLoader()
  },
}

module.exports = search



// WEBPACK FOOTER //
// ./src/modules/search.js